import React, { Key } from 'react';
import { Form } from 'antd';

import { EPCheckbox } from '@/comp';

interface NotificationPreferenceRowProps {
  field: {
    name: string | number;
    fieldKey?: Key;
  };
  severity: { icon: React.ReactNode };
  label: string;
  description: string;
  keyPrefix: string;
  isFormDisabled: boolean;
  t: (key: string) => string;
  showSms?: boolean;
}

const NotificationPreferenceRow: React.FC<NotificationPreferenceRowProps> = ({
  field,
  severity,
  label,
  description,
  keyPrefix,
  isFormDisabled,
  t,
  showSms = false,
}) => (
  <div className="notification-settings-row-container">
    <div className="severity-container">
      {severity.icon} <span className="label">{t(label)}</span>
    </div>
    <div className="notification-description-container">{t(description)}</div>
    <div className="notification-preference-container">
      <Form.Item
        {...field}
        name={[field.name, 'subscriptions', keyPrefix, 'email']}
        key={[field.fieldKey, `subscriptions.${keyPrefix}.email`] as unknown as Key}
        valuePropName="checked"
      >
        <EPCheckbox disabled={isFormDisabled}>{t('Email')}</EPCheckbox>
      </Form.Item>
      {showSms && (
        <Form.Item
          {...field}
          name={[field.name, 'subscriptions', keyPrefix, 'sms']}
          key={[field.fieldKey, `subscriptions.${keyPrefix}.sms`] as unknown as Key}
          valuePropName="checked"
          className="sms-form-item"
        >
          <EPCheckbox disabled={isFormDisabled}>{t('SMS')}</EPCheckbox>
        </Form.Item>
      )}
    </div>
  </div>
);

export default NotificationPreferenceRow;
